import { api } from "../../index";
import { setCsrfToken } from "../../session";
import type { SessionResult } from "../../../context/AuthContext";

export const verifyMfa = async (email: string, code: string): Promise<SessionResult> => {
  try {
    const response = await api.post<SessionResult>("/verify-mfa", { email, code });
    const session = response.data;
    if (!session.user || !session.csrfToken || !session.expiresAt) throw new Error("Resposta de autenticação inválida.");
    setCsrfToken(session.csrfToken);
    return session;
  } catch (error: any) {
    error.isExpired = String(error.response?.data?.message || "").toLowerCase().includes("expirado");
    throw error;
  }
};
